<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <input type="text" class="form-control" :class="errorMessage ? 'is-invalid' : ''" v-model="value">
    <div class="invalid-feedback">{{ errorMessage }}</div>
    <span v-if="help" class="form-text">{{ help }}</span>
  </form-layout>
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem';
import FormLayout from "@/views/templates/FormLayout";

export default {
  name: "VuexTextFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ''
    }
  },
  components: {
    FormLayout
  },
}
</script>
